export default "__VITE_ASSET__F9FgJ4nS__"